module.exports = "/images/ny-blck-11.jpg";